// --------------------------------------------------------------------------------------------------------
export class AppSubscription {
    SubscriptionKey: string;
    Description: string;
    CustomerId: number;
    SubscriptionToken: SubscriptionToken;
    Language: string;
    RegionalSettings: string;
    MinDBSizeToWarn: number;
    UnderMaintenance: boolean;
    CompanyInfo: string = '';
    CreationDate: Date;
    Tags: string[];
    Roles: string; //Aggiunto da raduan per mostrare i ruoli
    Status: number;
    ParentAccount: string; //aggiunto temp da roby per passare all'auditing, l'utente che sta eseguendo l'operazione
    MasterSubscriptionKey: string = '';
    TwoFA: boolean;
    TwoFADate: Date;
    TwoFAAdmin: string;

    constructor() {}

    assign(subscription?: AppSubscription) {
        this.SubscriptionKey = subscription.SubscriptionKey;
        this.Description = subscription.Description;
        this.CustomerId = subscription.CustomerId;
        this.SubscriptionToken = subscription.SubscriptionToken;
        this.Language = subscription.Language;
        this.RegionalSettings = subscription.RegionalSettings;
        this.MinDBSizeToWarn = subscription.MinDBSizeToWarn;
        this.UnderMaintenance = subscription.UnderMaintenance;
        this.CompanyInfo = subscription.CompanyInfo;
        this.CreationDate = subscription.CreationDate;
        this.Tags = subscription.Tags;
        this.Roles = subscription.Roles; //Aggiunto da raduan per mostrare i ruoli
        this.Status = subscription.Status;
        this.ParentAccount = subscription.ParentAccount;
        this.MasterSubscriptionKey = subscription.MasterSubscriptionKey;
        this.TwoFA = subscription.TwoFA;
        this.TwoFADate = subscription.TwoFADate;
        this.TwoFAAdmin = subscription.TwoFAAdmin;
    }
}

export interface SubscriptionData {
    Description: string;
    InstanceKey: string;
    IsEditable: boolean;
    SubscriptionKey: string;
    IsClicked: boolean;
    Roles: string[];
    CreationDate: Date;
    ExpirationDate: Date;
    TwoFA: boolean;
    TwoFADate: Date;
    TwoFAAdmin: string;
}

// --------------------------------------------------------------------------------------------------------
// export class CompanyInfo {
//     Company: string;
//     FiscalCode: string;
//     VatNumber: string;
//     Address: string;
//     ZipCode: string;
//     City: string;
//     CityCode: string;
//     Country: string;
//     Phone: string;
//     Email: string;

//     constructor() {
//         this.Company = '';
//         this.FiscalCode = '';
//         this.VatNumber = '';
//         this.Address = '';
//         this.ZipCode = '';
//         this.City = '';
//         this.CityCode = '';
//         this.Country = '';
//         this.Phone = '';
//         this.Email = '';
//     }
// }

// --------------------------------------------------------------------------------------------------------
export enum Mode {
    dvlp = 0,
    rnfs = 1,
    demo = 2,
    test = 3,
    rtm = 4,
    unknown = 5,
}
export enum DB {
    sqlazure = 0,
    onpremises = 1,
    othercloud = 2,
    privatecloud = 3,
    unknown = 4,
}

// --------------------------------------------------------------------------------------------------------
export class SubscriptionToken {
    subscriptionKey: string;
    country: string;
    edition: string;
    db: DB.unknown; // è giusto pre-settarlo ?
    mode: number;
    industryCode: string;
    industryName: string;
    modules: ModulesInfo;
    caltypes: CalType[];

    constructor() {}
}

export class ModulesInfo {
    module: ModuleInformation[];
}

export class ModuleInformation {
    fragment: string;
    name: string;
}
export class CalType {
    calType: number | string;
    nrCal: number;
}

export enum CompanyInfoValues {
    auditing = 'AUDITINGENABLED',
    security = 'SECURITYENABLED',
    CGM = 'CGMENABLED',
    visibility = 'VISIBILITYENABLED',
}

// --------------------------------------------------------------------------------------------------------
// mapping MagoCloud version (read from account-manager)
export class SubscriptionProductRelease {
    Major: number = 0;
    Minor: number = 0;
    Build: number = 0;
    Revision: number = 0;

    // return a SubscriptionVersion object from string
    public static create(version: string | object): SubscriptionProductRelease {
        let subVer = new SubscriptionProductRelease();
        let numbVersion: Array<string>;

        if (typeof version === 'string') {
            numbVersion = version?.split('.');
            if (numbVersion.length > 0) {
                let numMajor = numbVersion[0];
                let numMinor = numbVersion[1];
                let numBuild = numbVersion[2];
                let numRevision = '';
                //è un errore o voluto che alla variabile numRevision si vuole assegnare la variabile numbVersion[4] invece che numbVersion[3] ?
                if (numbVersion.length > 3) numRevision = numbVersion[4];
                subVer.Major = +numMajor;
                subVer.Minor = +numMinor;
                subVer.Build = +numBuild;
                subVer.Revision = +numRevision;
            }
        }
        return subVer;
    }
}
